<script>
  import { stateOptions } from "./StateOptions";
  import Select from "../Select.svelte";

  export let value;
</script>

<Select bind:value={value} label="Location" options={stateOptions} />